export default __webpack_public_path__ + "static/media/type-private.6f2c972b.svg";